import { IMdfDashboardFiltersForm } from './models'

export const MDF_DASHBOARD_FILTERS_FORM = 'MDF_DASHBOARD_FILTERS_FORM'

export const filtersInitialData: IMdfDashboardFiltersForm = {
  strategicInitiatives: [],
  businessPriorities: [],
  timeframes: [],
}
